import React, { useState, createRef } from 'react';
import Api from '../../../api/global.service';
import { useHistory } from 'react-router-dom';
import CardContainer from '../../../components/card/card-container.jsx';
import BlockUi from 'react-block-ui';
import SelectCiclo from '../../../components/select/select-ciclo.jsx';
import './ficha-master.css';
import ModalFichaMasterDescargaForm from './modals/modal-ficha-master-descarga-form.jsx';
import ModalFichaMasterEditar from './modals/modal-ficha-master-editar.jsx';
import useSecretUnlock from '../../../hooks/useSecretUnlock';

const VincularSic = () => {
  const history = useHistory();
  const [blocking, setBlocking] = useState(false);
  const [fichas, setFichas] = useState([]);
  const [editarUnlocked, handleTitleClick] = useSecretUnlock(7);

  const dialog = createRef();
  const dialogEditar = createRef();

  const getFichas = id_ciclo => {
    setBlocking(true);
    Api.getAll('ficha/kobo/master/lista', { master: 1, id_ciclo })
      .then(response => {
        setBlocking(false);
        setFichas(response.data);
      })
      .catch(() => {
        setBlocking(false);
      });
  };

  const setFilter = value => {
    getFichas(value.target.id);
  };

  return (
    <>
      <div className="ficha-master-container">
        <div className="row pb-4">
          <div className="col-xl-12">
            <div className="row justify-content-between mb-2">
              <SelectCiclo
                setFilter={evt => {
                  setFilter(evt);
                }}
              />
            </div>
            <CardContainer height="100%">
              <div className="row mb-4">
                <h2 className="col-xl-12 font-lato-normal-400 page-title" onClick={handleTitleClick}>
                  Fichas master disponibles
                </h2>
              </div>

              <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                {fichas.map(ficha => (
                  <div key={ficha?.id_kobo_ficha_principal} className="row ficha-master-item">
                    <div className="col-xl-4">
                      <div className="info-section">
                        <h4 className="ficha-title">{ficha?.nombre}</h4>
                        <p>
                          <strong>ID:</strong>
                          <span className="item-desc">{ficha?.id_kobo_ficha_principal}</span>
                        </p>
                        <p>
                          <strong>Descripción:</strong>
                          <span className="item-desc">{ficha?.descripcion}</span>
                        </p>
                        <p>
                          <strong>Cultivo:</strong>
                          <span className="item-desc">{ficha?.cultivo?.nombre}</span>
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="info-section">
                        <p>
                          <strong>Número de preguntas:</strong>
                          <span className="item-desc">{ficha?.numero_preguntas}</span>
                        </p>
                        <p>
                          <i className="fa fa-files-o info-icon"></i>
                          <strong>Fichas asociadas:</strong>
                          <span className="item-desc">{ficha?.numero_fichas}</span>
                        </p>
                        <p>
                          <i className="fa fa-clock-o info-icon"></i>
                          <strong>Ciclo:</strong>
                          <span className="item-desc">{ficha?.ciclo?.nombre}</span>
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="botones-ficha">
                        <button
                          type="button"
                          onClick={() => {
                            dialog.current.setData(ficha);
                            dialog.current.show();
                          }}
                          className="btn btn-success btn-action">
                          <i className="fa fa-download"></i>
                          <span>Descargar ficha</span>
                        </button>
                        {editarUnlocked && (
                          <button
                            type="button"
                            onClick={() => {
                              dialogEditar.current.setData(ficha);
                              dialogEditar.current.show();
                            }}
                            className="btn btn-warning btn-action">
                            <i className="fa fa-pencil"></i>
                            <span>Agregar variables a Master</span>
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => history.push(`/admin/ficha/master/detalle/${ficha.id_kobo_ficha_principal}`)}
                          className="btn btn-sirio btn-action">
                          <i className="fa fa-link"></i>
                          <span>Fichas Asociadas</span>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </BlockUi>
            </CardContainer>
          </div>
        </div>
        <ModalFichaMasterDescargaForm ref={dialog} title="Descarga formulario master" />
        <ModalFichaMasterEditar ref={dialogEditar} title="Editar Master" />
      </div>
    </>
  );
};

export default VincularSic;
